import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setFileCount,
  setFilePopupShown,
  setPopupShown,
} from "../../store/Slices/userSlice.js";
import Slider from "react-slick";
import "./Dashboard.scss";
import billingColumns from "../../columns/dashboard/columns";
import SkeletonTable from "../../components/table/SkeletonTable";
import {
  GetClientDashboard,
  GetBannerDashboard,
  VerifyDocument,
} from "../../api/request/dashboard/dashboard";
import toast from "react-hot-toast";
import moment from "moment";
import { Progress, Spin } from "antd";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ModalComponent from "../../components/modals/ModalComponent";
import LoadableButton from "../../components/button/LoadableButton";
import PaymentModal from "./components/PaymentModal";
import siteConfig from "../../config";
import CreateFiles from "../files/components/CreateFiles";
import CreateFileModal from "../files/components/CreateFileModal";
import StartFileModal from "./components/StartFileModal";
import totalFileColumns from "../../columns/totalfiles/totalfiles.js";
import View from "../../assets/View.jsx";
import UploadFile from "../../assets/UploadFile.jsx";
import GlobalTooltip from "../../components/common/GlobalTooltip.jsx";
import Eye from "../../assets/View.jsx";
import ConfirmationModal from "../../components/modals/ConfirmationModal.jsx";
import VerifyReasonDocModal from "./components/VerifyReasonDocModal.jsx";
import DonutChart from "../../components/chart/DonutChart.jsx";
import MpinModal from "./components/MpinModal.jsx";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    isFilePopupShown,
    userDetails: { mpin },
  } = useSelector((state) => state?.user);
  const [dashboardData, setDashboardData] = useState([]);
  const [services, setServices] = useState([]);
  const [billingData, setBillingData] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [payment, setPayment] = useState({});
  const [isOpenPaymentModal, setIsOpenPaymentModal] = useState(false);
  const [showIntialPopup, setShowIntialPopup] = useState(false);
  const [isCreateFileOpen, setIsCreateFileOpen] = useState(false);
  const [isReasonOpen, setIsReasonOpen] = useState(false);
  const [verifyDoc, setVerifyDoc] = useState([]);
  const [isVerifyDocOpen, setIsVerifyDocOpen] = useState(false);
  const [isVerifyLoading, setIsVerifyLoading] = useState(false);
  const [isVerifyReason, setIsVerifyReason] = useState(false);
  const [fileCounts, setFileCounts] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const [recentDocs, setRecentDocs] = useState([]);
  const [isMpinOpen, setIsMpinOpen] = useState(!mpin);

  const [dashboardCards, setDashboardCards] = useState([
    {
      title: "Files",
      icon: "/assets/icons/inprocess-files.svg",
      bgColor: "bg-[#cdd8ec]",
      path: "/files",
      subStats: [
        { label: "unsubmitted", value: 0, valueToSend: "unsubmitted" },
        { label: "inprocess", value: 0, valueToSend: "inprocess" },
        { label: "closed", value: 0, valueToSend: "closed" },
      ],
    },
    {
      title: "Action Required",
      icon: "/assets/icons/apply-signature.svg",
      bgColor: "bg-[#cfcced]",
      path: "/signature",
      subStats: [
        { label: "Signature", value: 0, id: "signature" },
        { label: "Billing", value: 0, id: "billing" },
        { label: "Verify Doc", value: 0, id: "verify_doc" },
      ],
    },
  ]);

  const contactInfo = [
    {
      label: "Phone",
      icon: "/assets/icons/phone.svg",
      value: dashboardData?.site_setting?.phone,
      url: `tel:${dashboardData?.site_setting?.phone}`,
    },
    {
      label: "Email",
      icon: "/assets/icons/email.svg",
      value: dashboardData?.site_setting?.email,
      url: `mailto:${dashboardData?.site_setting?.email}`,
    },
    {
      label: "Address",
      icon: "/assets/icons/location.svg",
      value: dashboardData?.site_setting?.address,
      url: dashboardData?.site_setting?.address_url,
    },
    {
      label: "Website",
      icon: "/assets/icons/web.svg",
      value: dashboardData?.site_setting?.website_url,
      url: dashboardData?.site_setting?.website_url,
    },
  ];

  const socialLinks = [
    {
      name: "Facebook",
      icon: "/assets/icons/facebook.svg",
      url: dashboardData?.site_setting?.facebook_url,
      bgColor: "bg-[#3B599933]",
    },
    {
      name: "Instagram",
      icon: "/assets/icons/instagram.svg",
      url: dashboardData?.site_setting?.instagram_url,
      bgColor:
        "bg-gradient-to-b from-[rgba(219,0,172,0.2)] to-[rgba(255,203,0,0.2)]",
    },
    {
      name: "LinkedIn",
      icon: "/assets/icons/linkedin.svg",
      url: dashboardData?.site_setting?.linkedin_url,
      bgColor: "bg-[#0B69C733]",
    },
    {
      name: "LinkedIn",
      icon: "/assets/icons/twiter.svg",
      url: dashboardData?.site_setting?.twitter_url,
      bgColor: "bg-[#0B69C733]",
    },
  ];

  const bannerSettings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  const recentDocsSettings = {
    vertical: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 1000,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: true,
    swipe: false,
  };

  const handleFileView = (data) => {
    navigate(`/file/${data?.files_id}`);
  };

  const getDashboardDetails = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetClientDashboard();
      const { data: bannerData } = await GetBannerDashboard();
      if (bannerData?.status) {
        setBannerData(bannerData?.data);
      }
      if (data?.status) {
        setDashboardData(data?.data);

        setServices(
          data?.data?.services?.map((item) => {
            return {
              ...item,
              service_name: (
                <div>
                  <p className="capitalize">{item?.service_name}</p>
                  <p className="text-gray-600">#{item?.file_number}</p>
                </div>
              ),
              progress: (
                <div className="min-w-[170px] w-auto">
                  <Progress
                    percent={Number(item?.completion_percentage).toFixed(0)}
                  />
                </div>
              ),
              action: (
                <div onClick={(e) => e?.stopPropagation()}>
                  <GlobalTooltip title={"View File"}>
                    <button onClick={() => handleFileView(item)}>
                      <View />
                    </button>
                  </GlobalTooltip>
                </div>
              ),
            };
          }) || []
        );

        setDashboardCards((prev) =>
          prev?.map((card) => {
            if (card?.title === "Files") {
              return {
                ...card,
                subStats: [
                  {
                    label: "Unsubmitted",
                    value: data?.data?.unsubmitted_files || 0,
                    valueToSend: "unsubmitted",
                  },
                  {
                    label: "In-progress",
                    value: data?.data?.in_process_files || 0,
                    valueToSend: "inprocess",
                  },
                  {
                    label: "Closed",
                    value: data?.data?.closed_files || 0,
                    valueToSend: "closed",
                  },
                ],
              };
            }
            if (card?.title === "Action Required") {
              return {
                ...card,
                subStats: [
                  {
                    label: "Signature",
                    value: data?.data?.waiting_for_action_count || 0,
                    id: "signature",
                  },
                  {
                    label: "Billing",
                    value: data?.data?.billing_details_count || 0,
                    id: "billing",
                  },
                  {
                    label: "Verify Doc",
                    value: data?.data?.recieved_verify_documents_count || 0,
                    id: "verify_doc",
                  },
                ],
              };
            }

            return card;
          })
        );

        setFileCounts(data?.data?.file_dout_chart_data);

        setRecentActivities(data?.data?.recent_activities || []);

        setRecentDocs(data?.data?.latest_documents || []);
        dispatch(setFileCount(data?.data?.total_files));
        {
          !isFilePopupShown && dispatch(setFilePopupShown(false));
        }

        // if (!data?.data?.total_files && !isPopupShown || mpin) {
        //   setShowIntialPopup(true);
        //   dispatch(setPopupShown(true));
        // }
        setBillingData(
          data?.data?.billing_details?.map((item) => {
            const isShowPayBtn = !item?.request_sended || item?.reason;
            return {
              ...item,
              action: (
                <div className="flex items-center gap-5">
                  <GlobalTooltip title={"View Invoice"}>
                    <a
                      href={item?.files?.invoice_pdf?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-semibold text-blue-500"
                    >
                      <Eye />
                    </a>
                  </GlobalTooltip>

                  {isShowPayBtn && (
                    <button
                      className="btn-primary !px-4 !py-1"
                      onClick={() => {
                        setPayment(item);
                        setIsOpenPaymentModal(true);
                      }}
                    >
                      Pay
                    </button>
                  )}
                </div>
              ),
              status: getStatus(item),
            };
          })
        );
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const colors = [
    "#A5D8FF",
    "#FFC9DE",
    "#B2F2BB",
    "#FFE066",
    "#D0BFFF",
    "#FF922B",
  ];

  useEffect(() => {
    getDashboardDetails();
  }, []);

  const getStatus = (item) => (
    <>
      {item?.reason ? (
        <div title={item?.reason} className="flex items-center gap-2">
          <p className="font-bold uppercase text-red-600">Rejected</p>
          <img
            src="/assets/icons/info.svg"
            className="size-4 cursor-pointer"
            onClick={() => {
              setPayment(item);
              setIsReasonOpen(true);
            }}
          />
        </div>
      ) : (
        <>
          {item?.request_sended ? (
            <p className="font-bold text-[#FF9800]">Wait For Verification</p>
          ) : (
            <p
              className={`font-bold uppercase ${
                item?.status === "paid" ? "text-green-500" : "text-red-600"
              }`}
            >
              {item?.status}
            </p>
          )}
        </>
      )}
    </>
  );

  const formatActivityDate = (date) => {
    return moment(date)
      .fromNow()
      .replace("second", "sec")
      .replace("minute", "min");
  };

  const setStatusData = () => {
    setBillingData((prev) => {
      return prev?.map((item) => {
        if (item?.id === payment?.id) {
          const updatedData = { ...item, request_sended: true, reason: "" };
          return {
            ...updatedData,
            status: getStatus(updatedData),
            action: (
              <GlobalTooltip title={"View Invoice"}>
                <a
                  href={item?.files?.invoice_pdf?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-blue-500 w-fit inline-block"
                >
                  <Eye />
                </a>
              </GlobalTooltip>
            ),
          };
        }
        return item;
      });
    });
  };

  const handleDocumentVerify = async () => {
    try {
      setIsVerifyLoading(true);
      const { data } = await VerifyDocument({ document_id: verifyDoc?.id });
      if (data?.status) {
        setIsVerifyDocOpen(false);
        getDashboardDetails();
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setIsVerifyLoading(false);
    }
  };

  const DashboardCard = ({
    title,
    total,
    subStats,
    icon,
    bgColor,
    navigate,
  }) => {
    const isFilesCard = title === "Files";

    const handleFileClick = (status) => {
      navigate("/files", { state: { status } });
    };

    return (
      <div
        className={`border rounded-xl p-4 bg-white md:col-span-1 sm:col-span-4 
        hover:shadow-md transition ${
          isFilesCard ? "cursor-pointer" : "cursor-default"
        }`}
        onClick={isFilesCard ? () => navigate("/files") : undefined}
      >
        <div className="flex flex-col justify-between h-full">
          <div className="flex justify-between items-center">
            <p className="font-bold text-lg">{title}</p>
            <div
              className={`${bgColor} rounded-xl size-10 flex items-center justify-center`}
            >
              <img src={icon} alt={`${title} icon`} className="w-6 h-6" />
            </div>
          </div>

          {/* Content */}
          {subStats ? (
            <div className="flex justify-between mt-3">
              {subStats.map((stat, idx) => (
                <SubStat
                  key={idx}
                  stat={stat}
                  isFilesCard={isFilesCard}
                  handleFileClick={handleFileClick}
                />
              ))}
            </div>
          ) : (
            <p className="card-count mt-3 text-lg font-semibold">{total}</p>
          )}
        </div>
      </div>
    );
  };

  const SubStat = ({ stat, isFilesCard, handleFileClick }) => {
    const { label, value, valueToSend, id } = stat;
    const clickable = value > 0;

    const handleScroll = () => {
      if (!id || !clickable) return;
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const handleClick = (e) => {
      if (isFilesCard && valueToSend) {
        e.stopPropagation();
        handleFileClick(valueToSend);
      }
    };

    return (
      <>
        {isFilesCard ? (
          <div
            className="flex flex-col items-center w-fit cursor-pointer"
            onClick={(e) => handleClick(e)}
          >
            <p className="text-lg font-semibold text-gray-800">{value}</p>

            <span className="text-xs font-medium">{label}</span>
          </div>
        ) : (
          <div
            className="flex flex-col items-center w-fit cursor-pointer"
            onClick={handleScroll}
          >
            <p className="text-lg font-semibold text-gray-800">{value}</p>
            <span className="text-xs font-medium">{label}</span>
          </div>
        )}
      </>
    );
  };

  const hasWaitingForAction = dashboardData?.waiting_for_action?.length > 0;
  const hasBilling = billingData?.length > 0;
  const hasVerifyDocs = dashboardData?.recieved_verify_documents?.some(
    (item) =>
      item?.reason_of_review_doc === null && item?.is_review_verify === 1
  );

  const shouldShowDashboardSection =
    hasWaitingForAction || hasBilling || hasVerifyDocs;

  return (
    <div className="grid xl:grid-cols-4 grid-cols-1 gap-5 sm:px-2 px-1">
      <div className="xl:col-span-3 space-y-5">
        <div
          className={`dashboard-banner rounded-xl overflow-hidden sm:h-[250px] h-[180px] ${
            isLoading ? "bg-[#0bafd450]" : "bg-primary"
          }`}
        >
          <div className="flex justify-center items-center h-full w-full">
            {isLoading ? (
              <Spin />
            ) : (
              <Slider {...bannerSettings} className="h-full w-full">
                {bannerData?.map((item, i) => (
                  <img
                    key={i}
                    src={item?.image}
                    alt="Banner"
                    className="sm:h-[250px] h-[180px] w-full object-cover"
                  />
                ))}
              </Slider>
            )}
          </div>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-1 xl:grid-cols-3 gap-5">
          <div className="xl:col-span-2">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-5 mb-5">
              {dashboardCards?.map((card, index) => (
                <DashboardCard key={index} {...card} navigate={navigate} />
              ))}
            </div>
            <div>
              <CreateFiles />
            </div>
          </div>

          <div className="recent-docs-container border rounded-2xl sm:p-6 p-5 bg-white h-full overflow-hidden">
            <h3 className="title mb-4">Recent Documents</h3>

            {isLoading ? (
              <div className="flex justify-center items-center h-40">
                <Spin size="large" />
              </div>
            ) : recentDocs?.length > 0 ? (
              <div className="ticker-wrapper">
                <div className="ticker-move">
                  {[...recentDocs, ...recentDocs].map((item, i) => (
                    <div
                      key={i}
                      className="flex items-center gap-3 border-b py-3 cursor-pointer px-2 hover:bg-[#fafafa]"
                      onClick={() => window.open(item?.path, "_blank")}
                    >
                      <div
                        className="rounded-xl w-10 h-10 flex items-center justify-center"
                        style={{
                          backgroundColor:
                            colors[Math.floor(Math.random() * colors?.length)],
                        }}
                      >
                        <img
                          src="/assets/icons/files.svg"
                          alt="icon"
                          className="w-6 h-6 object-contain"
                        />
                      </div>

                      <div className="flex-1 min-w-0">
                        <p className="sub-title capitalize truncate">
                          {item?.original_name}
                        </p>
                        <p className="text-gray-600 text-sm truncate">
                          {formatActivityDate(item?.created_at)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center text-gray-500 h-full">
                <img
                  src="/assets/images/no_data.png"
                  alt="no data"
                  className="w-28 h-28 sm:w-40 sm:h-40 mb-3 opacity-70"
                />
                <p>No recent documents found</p>
              </div>
            )}
          </div>
        </div>

        {shouldShowDashboardSection && (
          <div className="grid gap-5">
            {hasBilling && (
              <div
                className="border rounded-2xl sm:p-6 p-5 bg-White sm:max-h-[400px] max-h-[300px] overflow-y-auto"
                id="billing"
              >
                <p className="mb-5 title">Billing Details</p>
                <div className="overflow-x-auto">
                  <SkeletonTable
                    columns={billingColumns}
                    data={billingData}
                    isLoading={isLoading}
                    pagination={false}
                  />
                </div>
              </div>
            )}

            {hasWaitingForAction && (
              <div
                className="border rounded-2xl sm:p-6 p-5 space-y-5 bg-White sm:max-h-[400px] max-h-[300px] overflow-y-auto"
                id="signature"
              >
                <p className="mb-5 title">Signature</p>
                {dashboardData?.waiting_for_action?.map((item, index) => (
                  <div
                    key={index}
                    className={`border rounded-md flex sm:flex-row flex-col gap-3 justify-between sm:items-center sm:p-4 p-3 my-3 ${
                      item?.is_sign_done
                        ? "border-green-600 cursor-not-allowed"
                        : "border-Gray"
                    }`}
                  >
                    <div>
                      <p
                        className={`mid-title capitalize ${
                          item?.is_sign_done ? "text-green-600" : ""
                        }`}
                      >
                        {item?.original_name}
                      </p>
                      <p className="text-sm text-Gray mt-1">
                        {moment(item?.updated_at).format("lll")}
                      </p>
                      <div className="flex items-center gap-2 text-Gray mt-1">
                        <p className="capitalize">{item?.file_name}</p>
                        <p>#{item?.file_number}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      {item?.is_sign_done ? (
                        <p className="text-green-600 font-semibold text-base">
                          Signed
                        </p>
                      ) : (
                        <div className="flex items-center gap-2 flex-wrap">
                          <LoadableButton
                            className="!px-4"
                            onClick={() =>
                              window.open(
                                item?.path,
                                "_blank",
                                "noopener noreferrer"
                              )
                            }
                          >
                            <View color={"#fff"} /> View
                          </LoadableButton>
                          <LoadableButton
                            className="!px-4"
                            lable="Upload"
                            onClick={() => {
                              navigate(`/sign_pdf/${item?.sign_token}`);
                            }}
                          >
                            <UploadFile color={"#fff"} />
                            Signature
                          </LoadableButton>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {hasVerifyDocs && (
              <div
                className="border rounded-2xl sm:p-6 p-5 bg-White sm:max-h-[400px] max-h-[300px] overflow-y-auto"
                id="verify_doc"
              >
                <p className="mb-5 title">Review & Verify Document</p>
                {dashboardData?.recieved_verify_documents
                  ?.filter(
                    (item) =>
                      item?.reason_of_review_doc === null &&
                      item?.is_review_verify === 1
                  )
                  ?.map((item, index) => (
                    <div
                      key={index}
                      className={`border rounded-md flex sm:flex-row flex-col gap-3 justify-between sm:items-center sm:p-4 p-3 my-3 ${
                        item?.is_sign_done
                          ? "border-green-600 cursor-not-allowed"
                          : "border-Gray"
                      }`}
                    >
                      <div>
                        <p
                          className={`mid-title capitalize ${
                            item?.is_sign_done ? "text-green-600" : ""
                          }`}
                        >
                          {item?.original_name}
                        </p>
                        <p className="text-sm text-Gray mt-1">
                          {moment(item?.updated_at).format("lll")}
                        </p>
                        <div className="flex items-center gap-2 text-Gray mt-1">
                          <p className="capitalize">{item?.file_name}</p>
                          <p>#{item?.file_number}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2 flex-wrap md:justify-end">
                        {item?.is_sign_done ? (
                          <p className="text-green-600 font-semibold text-base">
                            Signed
                          </p>
                        ) : (
                          <>
                            <LoadableButton
                              className="!px-4"
                              onClick={() =>
                                window.open(
                                  item?.path,
                                  "_blank",
                                  "noopener noreferrer"
                                )
                              }
                            >
                              <View color={"#fff"} /> View
                            </LoadableButton>
                            <LoadableButton
                              className="!px-4"
                              lable="Upload"
                              onClick={() => {
                                setVerifyDoc(item);
                                setIsVerifyDocOpen(true);
                              }}
                            >
                              <UploadFile color={"#fff"} />
                              Verify
                            </LoadableButton>
                            <LoadableButton
                              lable="Request Changes"
                              onClick={() => {
                                setIsVerifyReason(true);
                                setVerifyDoc(item);
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}

        <div className="grid sm:grid-cols-1 md:grid-cols-1 xl:grid-cols-3 gap-5 ">
          <div className="md:col-span-1 xl:col-span-2 overflow-hidden">
            {services?.length ? (
              <div className="border rounded-xl p-5 bg-White h-full">
                <p className="title mb-4">Total Files ({services?.length})</p>
                <div className="overflow-auto h-full sm:max-h-[464px] max-h-[300px] scrollbar-hide">
                  <SkeletonTable
                    columns={totalFileColumns}
                    data={services}
                    isLoading={isLoading}
                    onRowClick={(data) => handleFileView(data)}
                  />
                </div>
              </div>
            ) : null}
          </div>

          <div className="bg-white border rounded-xl p-4 overflow-hidden ">
            <div className="flex items-center justify-between mb-4">
              <h3 className="title">Recent Activity</h3>
              <Link to="/activity" className="text-blue-500">
                View All
              </Link>
            </div>
            <div className="h-full sm:max-h-[464px] max-h-[300px] overflow-y-auto scrollbar-hide">
              <div className="sm:space-y-5 space-y-4">
                {recentActivities?.map((item) => (
                  <div key={item?.id} className="flex items-center gap-3">
                    <div className="flex-1">
                      <div className="flex items-center justify-between">
                        <p className="sub-title capitalize">{item?.activity}</p>
                        <p className="text-xs text-gray-500 text-right">
                          {formatActivityDate(item?.created_at)}
                        </p>
                      </div>
                      <p className="text-gray-600 text-wrap w-full sm:max-w-full max-w-60">
                        {item?.activity_message}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="xl:col-span-1 w-full space-y-5">
        <div className="flex flex-col bg-white border rounded-xl p-4">
          <h2 className="title">Files</h2>
          <div className="flex-1 flex items-center justify-center">
            <DonutChart fileCounts={fileCounts} />
          </div>
        </div>

        {Object.keys(dashboardData?.site_setting ?? {})?.length ? (
          <div className="px-4 bg-white p-5 border rounded-2xl">
            <h3 className="title mb-4">Contact Info</h3>
            {isLoading ? (
              <div className="!flex !justify-center !items-center min-h-[250px] w-full z-20">
                <Spin />
              </div>
            ) : (
              contactInfo?.map((item, index) => (
                <div
                  key={index}
                  className={`border-b flex items-center gap-3 py-2 ${
                    !!item?.value ? "" : "hidden"
                  }`}
                >
                  <div className="h-5 border-r pe-2">
                    <img src={item?.icon} alt="icon" />
                  </div>
                  <div className="w-[calc(100%-50px)] truncate">
                    <p className="text-Gray text-sm">{item?.label}</p>
                    <a
                      key={index}
                      href={item?.url || "#"}
                      target={
                        ["Phone", "Email"]?.includes(item?.label)
                          ? "_self"
                          : item?.url
                          ? "_blank"
                          : "_self"
                      }
                      rel="noopener noreferrer"
                      title={item?.value}
                    >
                      {item?.value}
                    </a>
                  </div>
                </div>
              ))
            )}
          </div>
        ) : null}

        <div className="bg-white border rounded-2xl">
          <h3 className="title  py-4 px-4">Social Links</h3>
          <div className="flex  gap-3  px-4">
            {socialLinks?.map((item, index) => (
              <a
                key={index}
                href={item?.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className={`${
                  item?.bgColor
                } h-8 w-8 rounded-full flex justify-center items-center gap-5 ${
                  item?.url ? "cursor-pointer" : "hidden"
                }`}
              >
                <img src={item?.icon} alt={item?.name} className="h-5 w-5" />
              </a>
            ))}
          </div>

          <div className="px-4 py-4">
            <div className="bg-[#F1F1F1] rounded-xl text-center p-6">
              <h4 className="title">Download mobile app</h4>
              <p className="text-sm py-2 px-1">
                Download {siteConfig?.name} to manage and track your documents
                anytime, anywhere—effortlessly!
              </p>
              <div className="gap-3 flex justify-center items-center pt-4">
                <a
                  href={dashboardData?.site_setting?.playstore_url || "#"}
                  target={
                    dashboardData?.site_setting?.playstore_url ? "_blank" : ""
                  }
                  rel="noopener noreferrer"
                  className="h-10 inline-block"
                >
                  <img
                    src="/assets/icons/playstore-btn.svg"
                    alt="Play Store"
                    className="object-contain h-full"
                  />
                </a>
                <a
                  href={dashboardData?.site_setting?.applestore_url || "#"}
                  target={
                    dashboardData?.site_setting?.applestore_url ? "_blank" : ""
                  }
                  rel="noopener noreferrer"
                  className="h-10 inline-block"
                >
                  <img
                    src="/assets/icons/appstore-btn.svg"
                    alt="App Store"
                    className="object-contain h-full"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal
        isOpen={isVerifyDocOpen}
        setIsOpen={setIsVerifyDocOpen}
        type="success"
        message="Are you sure this document is reviewed and verified?"
        onConfirm={handleDocumentVerify}
        isLoading={isVerifyLoading}
        loadingLabel="Verifying..."
      />

      <MpinModal
        isOpen={isMpinOpen}
        setIsOpen={setIsMpinOpen}
        setShowIntialPopup={setShowIntialPopup}
        initialData={dashboardData}
      />

      <PaymentModal
        isOpen={isOpenPaymentModal}
        setIsOpen={setIsOpenPaymentModal}
        payment={payment}
        setStatusData={setStatusData}
      />

      <ModalComponent
        title="Payment Rejected Reason"
        isOpen={isReasonOpen}
        setIsOpen={setIsReasonOpen}
      >
        <p className="text-base text-center">{payment?.reason}</p>
      </ModalComponent>

      <StartFileModal
        isOpen={showIntialPopup}
        setIsOpen={setShowIntialPopup}
        setIsCreateFileOpen={setIsCreateFileOpen}
      />

      <CreateFileModal
        isOpen={isCreateFileOpen}
        setIsOpen={setIsCreateFileOpen}
      />

      <VerifyReasonDocModal
        isOpen={isVerifyReason}
        setIsOpen={setIsVerifyReason}
        verifyData={verifyDoc}
        getDashboardDetails={getDashboardDetails}
      />
    </div>
  );
};

const CustomPrevArrow = ({ onClick }) => (
  <div
    className="bg-secondaryLight h-[38px] w-[38px] absolute left-4 top-1/2 transform -translate-y-1/2 rounded-full flex justify-center items-center pr-1 cursor-pointer z-10"
    onClick={onClick}
  >
    <img
      src="/assets/icons/left-angle.svg"
      alt="prev"
      className="object-contain"
    />
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div
    className="bg-secondaryLight h-[38px] w-[38px] absolute right-4 top-1/2 transform -translate-y-1/2 rounded-full flex justify-center items-center pl-1 cursor-pointer"
    onClick={onClick}
  >
    <img
      src="/assets/icons/right-angle.svg"
      alt="next"
      className="object-contain"
    />
  </div>
);

export default Dashboard;
